import { createAction } from "@reduxjs/toolkit";
import { LanguageCode } from "../../types/language.types";

enum LanguageActionTypes {
  SET_LANGUAGE = "[Language] SET",
}

export const setLanguageAction = createAction<LanguageCode>(LanguageActionTypes.SET_LANGUAGE);
